<template>
  <div v-show="withdrawPop.isShow" class="withdraw-pop" @click.stop>
    <section class="pop-content">
      <div class="g-close" @click="hidePop">
        <img src="../../assets/icon-close@2x.png" width="14" alt>
      </div>
      <header class="header">
        <div>
          <h3 class="title">
            去提现收入
          </h3>
        </div>
      </header>
      <div class="tip-bar">
        各渠道佣金盈利结算规则不同，请跳转提取收入
      </div>
      <div class="media-list">
        <div class="item">
          <div class="hd jd" />
          <div class="bd">
            <h3 class="title">
              京东联盟
            </h3>
            <p class="desc">
              分销渠道
            </p>
          </div>
          <div>
            <a target="blank" href="https://union.jd.com/accountingCenter">
              <qc-button>提现佣金</qc-button>
            </a>
          </div>
        </div>
        <div class="item">
          <div class="hd mk" />
          <div class="bd">
            <h3 class="title">
              企鹅小店
            </h3>
            <p class="desc">
              自营渠道
            </p>
          </div>
          <div>
            <qc-button @click="showWithdrawGuidePop">
              提现佣金
            </qc-button>
          </div>
        </div>
        <div class="item">
          <div class="hd pdd" />
          <div class="bd">
            <h3 class="title">
              拼多多
            </h3>
            <p class="desc">
              分销渠道
            </p>
          </div>
          <div>
            <a target="blank" href="https://jinbao.pinduoduo.com/fund/blance">
              <qc-button>提现佣金</qc-button>
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import commonMixin from '@/mixins/common';
import { mapState } from 'vuex';

export default {
  name: 'BindJdPop',
  mixins: [commonMixin],
  data() {
    return {};
  },
  computed: {
    ...mapState({
      profile: state => state.userCenter.profile,
      withdrawPop: state => state.common.withdrawPop,
    }),
  },
  methods: {
    hidePop() {
      this.$store.commit('common/HIDE_WITHDRAW_POP');
    },
    showWithdrawGuidePop() {
      this.hidePop();
      this.$store.commit('common/SHOW_WITHDRAW_GUIDE_POP');
    },
  },
};
</script>

<style lang="less" scoped>
@popH: 410px;
@popHeaderH: 90px;
@popFooterH: 80px;

.withdraw-pop {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 3;
  background-color: rgba(33, 33, 33, 0.6);
  .g-close {
    position: absolute;
    right: 20px;
    top: 34px;
    width: 20px;
    height: 20px;
    img {
      cursor: pointer;
    }
  }
  .pop-content {
    position: relative;
    width: 500px;
    min-height: @popH;
    background-color: #fff;
    border-radius: 4px;
    .header {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      height: @popHeaderH;
      .title {
        margin-bottom: 10px;
        font-size: 20px;
      }
    }
    .tip-bar {
      display: flex;
      align-items: center;
      padding: 0 20px;
      border: 1px solid #97c7ff;
      background-color: #e5f0ff;
      color: #003b80;
      height: 40px;
    }
    .media-list {
      padding: 30px;
      .item {
        margin-top: 20px;
        height: 112px;
        display: flex;
        align-items: center;
        border: 1px solid #e2e2e2;
        background-color: #fff;
        padding: 0 20px;

        .hd {
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center center;
          width: 72px;
          height: 72px;
          margin-right: 20px;

          &.mk {
            background-image: url("../../assets/mk-logo.png");
          }
          &.jd {
            background-image: url("../../assets/jd-logo.png");
          }
          &.pdd {
            background-image: url("../../assets/pdd-logo.png");
          }
        }
        .bd {
          flex: 1;
          .title {
            font-size: 20px;
          }
          .desc {
            margin-top: 10px;
            font-size: 14px;
          }
        }
      }
    }
    .inner-content {
      height: calc(@popH - @popHeaderH - @popFooterH);
      display: flex;
      justify-content: center;
      background-color: rgb(239, 239, 239);
      .guide-item {
        padding: 20px 10px;
        text-align: center;
        flex: 1;
        .tip {
          margin-bottom: 10px;
        }
        .image {
          height: 234px;
        }
        &:nth-child(3) {
          margin: 0 10px;
        }
      }
      .guide-item1 {
        display: flex;
        justify-content: center;
        align-items: center;
        .tip {
          margin-top: 20px;
          .em {
            color: var(--ui-main-color);
          }
        }
      }
    }

    .footer {
      display: flex;
      justify-content: center;
      align-items: center;
      height: @popFooterH;
    }
  }
  .pop-content1 {
    position: relative;
    width: 500px;
    height: 500px;
    background-color: #fff;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    .tip {
      margin-top: 20px;
    }
    .panel-wrap {
      position: relative;
      top: 100px;
    }
  }
}
</style>
